import { CustomBottomBar, ListItem } from '@components';
import { Button, Container, Icon, Typography } from '@design-system';
import { GrFormCheckmark } from 'react-icons/gr';
import { useHomeSecurityMenuPageVM } from './useHomeSecurityMenuPageVM';

export const HomeSecurityMenuPage: React.FC = () => {
    const { steps, hasCompletedAllSteps, handleNextStep } = useHomeSecurityMenuPageVM();

    return (
        <div className="home-security-menu">
            <Container className="steps-container">
                {steps.map((step) => (
                    <ListItem
                        key={step.title}
                        className={step.isDone ? 'done' : ''}
                        title={step.title}
                        type="default"
                        icon={step.icon}
                        onClick={step.isDone ? () => {} : step.onClick}
                        customRightIcon={step.isDone ? <Icon icon={<GrFormCheckmark />} size={38} color="green" /> : null}
                    />
                ))}
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="marine" size="fullwidth" onClick={handleNextStep} disabled={!hasCompletedAllSteps}>
                    <Typography intrinsic="h4">Valider l'accueil</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
